export default {
	// api请求地址
	baseUrl: 'http://heshi.ourmou.com',
	
	// 图片域名
	imgDomain: 'http://heshi.ourmou.com',
	
	// 前端域名
	webDomain: 'http://heshi.ourmou.com/web',
	
	// 腾讯地图key
	mpKey: 'FTQBZ-E2C6W-Y22RH-RDW72-CRM5V-Z3B2B',
	
	// 客服
	webSocket: 'ws://heshi.ourmou.com/wss',
	
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500
}